import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-11/task-01";

const task: Slide = {
  titleHtml: `In the vicinity of a rigid piston vibrating</br>at the entrance of a tube with a larger diameter.`,
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
